import React, { cloneElement, useState, useCallback } from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import { translate } from '../../../i18n/I18nProvider';
import CustomDialogTitle from '../../../partials/customDialogTitle/CustomDialogTitle';
import DraggableDialog from '../../../partials/DraggableDialog';
import UserDetailsTable from './UserDetailsTable';
import styles from '../styles';

const UserDetailDialog = ({ user, children, classes }) => {
  const [open, setOpen] = useState(false);

  const onOpenDialog = useCallback(() => {
    setOpen(true);
    // eslint-disable-next-line
  }, []);

  const onCloseDialog = useCallback(() => {
    setOpen(false);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {cloneElement(children, { onClick: onOpenDialog })}
      <Dialog
        maxWidth={false}
        PaperComponent={DraggableDialog}
        classes={{
          paper: classes.content
        }}
        open={open}
        onClose={onCloseDialog}
      >
        <CustomDialogTitle onCloseClick={onCloseDialog}>
          <div className={classes.title}>{translate('USER_DETAILS')}</div>
        </CustomDialogTitle>
        <DialogContent className={classes.dialogContent}>
          <UserDetailsTable data={user} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default withStyles(styles)(UserDetailDialog);
